import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';

import { authentication } from './authentication';
import { notification } from './notification';
import { global } from './global';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
    state: {
        version: '1.0.0',
    },
    modules: {
        authentication,
        notification,
        global,
    },
};

export default new Vuex.Store<RootState>(store);
